export const DocumentSettingsKeys = [
    'tasks',
    'access',
    'metadata',
    'external-sharing',
    'approval',
    'esigning',
    'attachments',
];
